import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {AlertListService, QueryStringService} from '@xref/ngx';
import * as Cookies from 'js-cookie';

import {environment} from '../../../../../environments/environment';
import Constants from '../../../../shared/constants';
import {IdService, SsoDTO} from "../../../../services/id/id.service";

@Component({
    selector: 'xlog-open-id-sso',
    templateUrl: './open-id-sso.component.pug',
    styleUrls: ['./open-id-sso.component.scss'],
    standalone: false
})
export class OpenIdSsoComponent implements OnInit {

    data = new SsoDTO();

    constructor(
        private qString: QueryStringService,
        private alertList: AlertListService,
        private id: IdService,
        private router: Router,
        private jwtHelper: JwtHelperService
    ) {
    }

    ngOnInit() {
        let error = this.qString.getHash('error');
        if (!error || error === 'null') {
            error = this.qString.getParam('error');
        }
        if (error) {
            this.alertList.append([{
                keepOnRouteChange: true,
                active: true,
                type: 'danger',
                messageKey: 'sso.google.unableToVerifyRequest'
            }]);
            return this.router.navigate(['/']);
        }
        let uuid = decodeURIComponent(this.qString.getHash('state'));
        if (!uuid || uuid === 'null') {
            uuid = decodeURIComponent(this.qString.getParam('state'));
        }
        // If returned UUID does not match stored, show alert and redirect user to login page
        if (!uuid || uuid != Cookies.get(Constants.SSO_UUID)) {
            this.alertList.append([{
                keepOnRouteChange: true,
                active: true,
                type: 'danger',
                messageKey: 'sso.google.unableToVerifyRequest'
            }]);
            return this.router.navigate(['/']);
        }

        let idToken = decodeURIComponent(this.qString.getHash('id_token'));
        if (!idToken || idToken === 'null') {
            idToken = decodeURIComponent(this.qString.getParam('id_token'));
        }
        if (idToken !== null && idToken !== 'null') {
            return this.validate_microsoft(idToken);
        } else {
            return this.validate_google();
        }
    }

    authenticateSuccess = (res: any) => {
        // Clear cookies
        Cookies.remove(Constants.SSO_UUID, {domain: environment.DOMAIN});
        Cookies.remove(Constants.SSO_NONCE, {domain: environment.DOMAIN});
        Cookies.remove(Constants.SSO_REDIRECT_URL, {domain: environment.DOMAIN});
        if (this.id.ent_9105) {
            this.id.redirectToReturnUrl();
        } else {
            this.id.DeprecatedRedirectToReturnUrl();
        };
    };

    authenticateError = (res: any) => {
        const err = res.error;

        if (
            err.message === 'User company is inactive' ||
      err.message === 'User is inactive'
        ) {
            this.alertList.append([{
                keepOnRouteChange: true,
                active: true,
                type: 'danger',
                messageKey: 'alerts.auth.XREF_USER_INACTIVE'
            }]);

        } else {
            this.alertList.append([{
                keepOnRouteChange: true,
                active: true,
                type: 'danger',
                messageKey: 'alerts.sso.userNotCredentialed'
            }]);
        }

        this.router.navigate(['/']);
    };

    authenticate_google() {
        // Populate model
        this.data.hd = decodeURIComponent(this.qString.getParam('hd'));
        this.data.code = decodeURIComponent(this.qString.getParam('code'));
        this.data.redirect_url = Cookies.get(Constants.SSO_REDIRECT_URL);
        this.data.email = Cookies.get(Constants.LOGIN_EMAIL);

        // If missing required params, redirect to login page
        if (!this.data.hd || !this.data.code) {
            this.alertList.append([{
                keepOnRouteChange: true,
                active: true,
                type: 'danger',
                messageKey: 'sso.google.unableToVerifyRequest'
            }]);
            return this.router.navigate(['/']);
        }

        this.data.uuid = Cookies.get(Constants.ORG_UID);
        this.id.login(this.authenticateSuccess, this.authenticateError, undefined, this.data);
    }

    authenticate_microsoft(id_token) {
    // Populate model
        this.data.id_token = id_token;
        this.data.code = decodeURIComponent(this.qString.getHash('code'));
        this.data.redirect_url = Cookies.get(Constants.SSO_REDIRECT_URL);
        this.data.email = Cookies.get(Constants.LOGIN_EMAIL);

        // If missing required params, redirect to login page
        if (!this.data.code) {
            this.alertList.append([{
                keepOnRouteChange: true,
                active: true,
                type: 'danger',
                messageKey: 'sso.google.unableToVerifyRequest'
            }]);
            return this.router.navigate(['/']);
        }

        this.data.uuid = Cookies.get(Constants.ORG_UID);
        this.id.login(this.authenticateSuccess, this.authenticateError, undefined, this.data);
    }

    private validate_google() {
        // Nothing to validate
        this.authenticate_google();
    }

    private validate_microsoft(id_token: string) {
        const token = this.jwtHelper.decodeToken(id_token);
        // If returned UUID does not match stored, show alert and redirect user to login page
        if (!token || !token.nonce || token.nonce != Cookies.get(Constants.SSO_NONCE)) {
            this.alertList.append([{
                keepOnRouteChange: true,
                active: true,
                type: 'danger',
                messageKey: 'sso.google.unableToVerifyRequest'
            }]);
            return this.router.navigate(['/']);
        }

        this.authenticate_microsoft(id_token);
    }
}
